import React from 'react'
import ToolbarButton from './ToolbarButton'
import CloseIcon from '@material-ui/icons/Close'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	root: {
		marginLeft: theme.spacing.unit * -2,
		color: "red"
	}
})

const CloseButton = ({ type, onClick, classes, ...props }) => {
	switch (type) {
		case 'CLOSE':
			return (
				<div className={classes.root}>
					<ToolbarButton
						title = "Stäng"
						icon = {<CloseIcon />}
						onClick = {onClick} 
						{...props}
					/>
				</div>
			)
		case 'BACK':
			return (
				<div className={classes.root}>
					<ToolbarButton
						title = "Tillbaka"
						icon = {<ArrowBackIcon />}
						onClick = {onClick} 
						className = {classes.root}
						{...props}
					/>
				</div>
			)
		default:
			return null
	}
}

export default withStyles(styles)(CloseButton)



// WEBPACK FOOTER //
// ./src/components/Page/CloseButton.js